import { axiosInstance } from '@/modules/shared/lib/axios'

export type DriverDayInfo = {
  notes: string | null
  switchViolation: boolean
}

// Limit pilnowany też na serwerze (DriverDayNotesLimit).
export const DAY_NOTES_MAX_LENGTH = 5000

type DayRef = {
  companyId: string
  driverId: number
  /** YYYY-MM-DD */
  date: string
}

const base = (companyId: string) => `/api/${companyId}/driverCalendar/dayInfo`

export function getDriverDayInfo({ companyId, driverId, date }: DayRef) {
  return axiosInstance.get<DriverDayInfo>(base(companyId), {
    params: { driverId, date },
  })
}

export function saveDriverDayInfo({
  companyId,
  driverId,
  date,
  ...info
}: DayRef & DriverDayInfo) {
  return axiosInstance.post<DriverDayInfo>(base(companyId), {
    driverId,
    date,
    ...info,
  })
}
